<template>
  <div
    class="el-input"
    :class="{ sizeCustom, 'is-disabled': $attrs.disabled }"
  >
    <div
      class="el-input__wrapper"
      :class="{'is-focus': isFocused}"
    >
      <div class="el-input__prefix" v-if="icon !== ''">
        <span class="el-input__prefix-inner">
          <i><font-awesome-icon :icon="icon" /></i>
        </span>
      </div>
      <input
        v-bind="$attrs"
        v-model="display"
        v-mask="config"
        class="el-input__inner"
        @focus="isFocused = true"
        @blur="isFocused = false"
        @input="handleInput"
      >
    </div>
  </div>
</template>

<script>
import tokens from './tokens.js';
import maskit from './maskit';
import dynamicMask from './dynamic-mask';
import mask from './directive.js';

export default {
  name: 'TheMask',
  directives: { mask },
  props: {
    modelValue: [String, Number],
    mask: {
      type: [String, Array],
      required: true,
    },
    masked: {
      type: Boolean,
      default: false, // raw
    },
    tokens: {
      type: Object,
      default: () => tokens,
    },
    size: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      lastValue: null, // avoid unecessary emit when has no change
      display: this.modelValue,
      isFocused: false,
      sizeCustom: this.size ? `el-input--${this.size}` : '',
    };
  },
  computed: {
    config() {
      return {
        mask: this.mask,
        tokens: this.tokens,
        masked: this.masked,
      };
    },
  },
  watch: {
    modelValue(newValue) {
      if (newValue !== this.lastValue) {
        this.display = newValue;
      }
    },
    masked() {
      this.refresh(this.display);
    },
  },

  mounted() {
    this.applyMaskToInitialValue();
  },
  methods: {
    handleInput(event) {
      this.applyMask(event.target.value);
    },
    applyMaskToInitialValue() {
      if (this.$attrs && this.$attrs.modelValue) {
        const maskedValue = this.applyMask(this.$attrs.modelValue);
        this.display = maskedValue;
      }
    },

    applyMask(value) {
      this.display = value;
      const maskedValue = Array.isArray(this.mask)
        ? dynamicMask(maskit, this.mask, tokens)(value, this.mask, this.masked, tokens)
        : maskit(value, this.mask, this.masked, tokens);

      if (maskedValue !== this.lastValue) {
        this.lastValue = maskedValue;
        this.updateValue(maskedValue);
      }
    },

    updateValue(value) {
      if (!Array.isArray(this.mask) && this.mask.startsWith('##/##')) this.$emit('update:modelValue', this.display);
      else this.$emit('update:modelValue', value);
    },
  },
};
</script>
<style scoped>
  .is-focus{
    box-shadow: 0 0 0 1px var(--el-input-focus-border-color) inset;
  }

  .el-input--small {
    height: 24px;
    font-size: 12px;
  }

  .el-input--large {
    height: 40px;
    font-size: 14px;
  }
</style>
